<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-titlepage title-page" epub:type="titlepage" id="title-page">
<div class="title-page-title-subtitle-block">
<h1 class="title-page-title case-upper">A PARTICULAR MAN</h1>
</div>
<div class="title-page-contributor-block">
<div class="title-page-contributor-primary-block">
<h2 class="title-page-contributor title-page-contributor-primary title-page-contributor-without-introduction"><span class="title-page-contributor-name case-upper">LESLEY GLAISTER</span></h2>
</div>
</div>
<div class="publisher-block">
<div class="title-page-publisher-logo-block title-page-publisher-logo-aspect-wide">
<div class="title-page-publisher-logo-size-container publisher-logo-width-644">
<a class="link-contains-image" href="http://www.bloodhoundbooks.com" target="_blank"><img alt="Bloodhound Books" class="title-page-publisher-logo-image" src="images/bloodhound-books-new.jpg"/></a>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// title-page.vue?7919fcce